import { render, staticRenderFns } from "./NavVertical.vue?vue&type=template&id=a0e9c186&"
import script from "./NavVertical.vue?vue&type=script&lang=js&"
export * from "./NavVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports